/* Component Dependencies */
var searchOptionsTemplate = require('templates/searchOptions.hbs');
var AriesComponent = require('libs/aries-component');
var PubSub = require('libs/pub-sub');
var $ = require('jquery');

PubSub.register(AriesComponent.extend({
  type: 'searchOptions',
  events: {
    'click li a': 'tabSelected'
  },
  template: {
    'searchOptions': searchOptionsTemplate
	},
	bindEvents: function() {
		var _self = this;
    $(window).on('load', function() {
      _self.setActiveTab();      
    });
  },
  setActiveTab: function() {
    var _self = this,
    $activeTab = _self.$el.find('.js-advanced-search-list.ui-tabs-selected');
    if($activeTab.length){
      $activeTab.addClass('m-list-tabs-active');
      _self.pubsub.publish('ADVANCED_SEARCH_TAB_CLICK', [$activeTab.find('a').attr('data-target')]);
    }
	},
  tabSelected: function(e) {
    e.preventDefault();
    var target = $(e.currentTarget);
    this.highlightTab(target);
    this.pubsub.publish('ADVANCED_SEARCH_TAB_CLICK', [target.attr('data-target')]);
  },
  highlightTab: function(elem) {
    this.$el.find(".js-advanced-search-list").removeClass("m-list-tabs-active");
    elem.parent().addClass("m-list-tabs-active");
  }
}));
